import React from 'react';
import { Link } from 'react-router-dom';
import { logout } from '../services/auth';
import './Layout.css';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const handleLogout = () => {
    logout();
  };

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="header-content">
          <Link to="/dashboard" className="header-logo">
            <h1>Tenant Management</h1>
          </Link>
          <nav className="header-nav">
            <Link to="/dashboard" className="nav-link">Dashboard</Link>
            <Link to="/tenants" className="nav-link">Tenants</Link>
            <Link to="/solutions" className="nav-link">Solutions</Link>
            <Link to="/maintainers" className="nav-link">Maintainers</Link>
            <Link to="/amazon-sqs" className="nav-link">Amazon SQS</Link>
            <button onClick={handleLogout} className="logout-button">
              Logout
            </button>
          </nav>
        </div>
      </header>
      <main className="layout-main">
        {children}
      </main>
    </div>
  );
};

export default Layout;



